import { render, staticRenderFns } from "./PRNViewer.vue?vue&type=template&id=5f3ae814&scoped=true&"
import script from "./PRNViewer.vue?vue&type=script&lang=js&"
export * from "./PRNViewer.vue?vue&type=script&lang=js&"
import style0 from "./PRNViewer.vue?vue&type=style&index=0&id=5f3ae814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ae814",
  null
  
)

export default component.exports